<template>
  <div>
    <naj-box :title="local.bankruptcy.bankruptcyFile.replyMemos.cardHeader">
      <v-row>
        <v-col cols="12">
          <naj-input
            class="department-type-input"
            :label="local.bankruptcy.replyMemo.debtDataCorrect"
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.debtDataCorrect"
            :items="yesNoOptions"
            item-value="id"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.debtDataCorrect === booleanEnum.no"
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.bankruptcy.replyMemo.debtDataIsNotCorrectReasons"
            :value.sync="formModel.debtDataIsNotCorrectReasons"
            :disabled="isViewMode"
            validates="max:200|required"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <naj-input
            class="department-type-input"
            :label="`${local.bankruptcy.replyMemo.debtorAgreedOnOpeningProcedure} ${requiredData.procedureName} ؟`"
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.debtorAgreedOnOpeningProcedure"
            :items="yesNoOptions"
            item-value="id"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.debtorAgreedOnOpeningProcedure === booleanEnum.no"
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.bankruptcy.replyMemo.debtorNotAgreedOnOpeningProcedureReasons"
            :value.sync="formModel.debtorNotAgreedOnOpeningProcedureReasons"
            :disabled="isViewMode"
            validates="max:200|required"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <naj-input
            class="department-type-input"
            :label="local.bankruptcy.replyMemo.debtorCanContinueHisBusiness"
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.debtorCanContinueHisBusiness"
            :items="yesNoOptions"
            item-value="id"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.debtorCanContinueHisBusiness === booleanEnum.no"
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.bankruptcy.replyMemo.debtorCanNotContinueHisBusinessReasons"
            :value.sync="formModel.debtorCanNotContinueHisBusinessReasons"
            :disabled="isViewMode"
            validates="max:200|required"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <naj-input
            class="department-type-input"
            :label="local.bankruptcy.replyMemo.totalDebts"
            :type-id="formFieldType.number"
            :value.sync="formModel.totalDebts"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col cols="4">
          <naj-input
            class="department-type-input"
            :label="local.bankruptcy.replyMemo.numberOfWorkers"
            :type-id="formFieldType.number"
            :value.sync="formModel.numberOfWorkers"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col cols="4">
          <naj-input
            class="department-type-input"
            :label="local.bankruptcy.replyMemo.totalOfAssets"
            :type-id="formFieldType.number"
            :value.sync="formModel.totalOfAssets"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.bankruptcy.replyMemo.debtorActivity"
            :value.sync="formModel.debtorActivity"
            validates="max:200|required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>

      <v-row v-if="isNewMode">
        <v-col
          v-if="formModel.financialStatementAttachmentFileId"
          cols="3"
        >
          <p class="objection-judgment-confirm-text">
            {{ local.bankruptcy.replyMemo.financialStatementsAttachment }}
          </p>
          <attachment-card
            :file="{ ...uploadedFile }"
            :show-delete-button="isNewMode"
            @deleteAttachment="showDeleteAttachment = true"
            @viewAttachment="showViewAttachment = true"
          ></attachment-card>
        </v-col>
        <v-col
          v-else
          class="objection-note-attachment"
          cols="12"
        >
          <p class="objection-judgment-confirm-text">
            {{ local.bankruptcy.replyMemo.financialStatementsAttachment }}
          </p>
          <load-local-attachment
            :max-file-size="5"
            :upload-disabled="isViewMode"
            @fileSelected="fileSelected"
          >
          </load-local-attachment>
        </v-col>
      </v-row>
      <v-row v-if="isViewMode">
        <v-col
          v-if="formModel.financialStatementAttachmentFileId"
          cols="3"
        >
          <p class="objection-judgment-confirm-text">
            {{ local.bankruptcy.replyMemo.financialStatementsAttachment }}
          </p>
          <attachment-card
            :file="{ ...uploadedFile }"
            :show-delete-button="false"
            @viewAttachment="showViewAttachment = true"
          ></attachment-card>
        </v-col>
      </v-row>
    </naj-box>

    <render-attachment-modal
      :attachment-file="uploadedFile"
      :modal-visibility="showViewAttachment"
      @modalClose="showViewAttachment = false"
    >
    </render-attachment-modal>

    <naj-confirmation
      :show-modal="showDeleteAttachment"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.bankruptcy.replyMemo.financialStatementsAttachmentDeleteConfirmation"
      :ok-btn-label="local.common.remove"
      @ok="confirmDeleteAttachment"
      @cancel="showDeleteAttachment = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');

import LoadLocalAttachment from '@/components/shared/attachment-modal/load-local-attachment.vue';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';
import { booleanEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'ReplyMemoForm',
  inject: ['$validator'],
  components: {
    LoadLocalAttachment,
    RenderAttachmentModal,
    AttachmentCard,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      judgements: [],
      showDeleteAttachment: false,
      showViewAttachment: false,
      loading: true,
      booleanEnum,
    };
  },
  computed: {
    ...mapLUTState([
      'yesNoOptions',
    ]),
    uploadedFile() {
      if (this.formModel.financialStatementAttachmentFileId) {
        return {
          name: this.formModel.financialStatementAttachmentFileName,
          sharePointId: this.formModel.financialStatementAttachmentFileId,
          isImage: this.formModel.financialStatementAttachmentFileType.startsWith('image'),
          fileType: this.formModel.financialStatementAttachmentFileType,
        };
      }
      return {};
    },
    isViewMode() {
      return !!this.$route.params.replyMemoObjectKey;
    },
    isNewMode() {
      if (this.isViewMode) return false;
      return (!this.$route.params.replyMemoObjectKey);
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'uploadAttachment',
    ]),

    fileSelected({ selectedAttachment: attachment }) {
      this.loading = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');
        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.$set(this.formModel, 'financialStatementAttachmentFileName', attachment.name);
            this.$set(this.formModel, 'financialStatementAttachmentFileId', data);
            this.$set(this.formModel, 'financialStatementAttachmentFileType', attachment.fileObject.type);
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };
      reader.readAsDataURL(attachment.fileObject);
    },

    confirmDeleteAttachment() {
      this.$delete(this.formModel, 'financialStatementAttachmentFileName');
      this.$delete(this.formModel, 'financialStatementAttachmentFileId');
      this.$delete(this.formModel, 'financialStatementAttachmentFileType');
      this.showDeleteAttachment = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}
.memorandum-challenge-alert-container {
  .alert-notification {
    display: block;
    color: #f6c645;
    font-size: 14px;
  }
  .message {
    font-size: 16px;
    color: #faad14;
  }
}

.objection-judgment-confirm-text {
  color: darkred;
  font-size: 1rem;
  margin-bottom: 0;
}

.objection-note-attachment {
  display: flex;
  .objection-judgment-confirm-text {
    margin-left: 10px;
  }
  .uplaod-attachments-button .img-actions {
    width: 100% !important;
  }
}

::v-deep .attachment-item {
  cursor: pointer;
}
</style>